import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { api, setCsrfToken } from '../api/client';
import { setErrorTrackingUser } from '../lib/errorTracking';

/** Ends the session and forgets everything this login had loaded. */
export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return () => {
    void api('/auth/logout', { method: 'POST' }).then(() => {
      setCsrfToken(null);
      setErrorTrackingUser(null);
      queryClient.clear();
      void navigate('/login');
    });
  };
}
